<template>
<div>
  <v-toolbar flat color="transparent">
    <v-app-bar-nav-icon
      v-if="$vuetify.breakpoint.smAndDown && !drawer"
      @click="onToggleDrawer()"
    ></v-app-bar-nav-icon>
    <v-div>
      <v-btn-toggle @change="changeDept" v-model="activeDeptId" active-class="success">
        <template v-for="d in depts" >
          <v-badge
            overlap
            v-if="d.cnt>0"
            :key="d"
            color="green"
            :content="d.cnt"
          >
            <v-btn small class="float-left ml-3" v-html="d.name"></v-btn>
          </v-badge>
          <v-btn small :key="d" v-else class="float-left ml-3" v-html="d.name"></v-btn>
        </template>
      </v-btn-toggle>
    </v-div>
    <v-spacer></v-spacer>
    <v-icon color="info" v-if="level>10" class="mr-3" @click="editDialog()">fas fa-gears</v-icon>
    <v-icon color="info" @click="instructions_dialog=true">fas fa-info-circle</v-icon>
    <!--
    <v-avatar
      v-if="group"
      size="35px"
      color="grey lighten-4"
      :class="$vuetify.breakpoint.smAndDown ? 'mx-3' : 'mr-3'"
    >
      <img :src="group.user.avatar" alt="avatar" />
    </v-avatar>
    <v-toolbar-title>{{ group.user.name }}</v-toolbar-title>-->
  </v-toolbar>
    <v-dialog v-model="instructions_dialog" max-width="800">
      <v-card>
        <v-card-title class="text-h5 mb-3"
          >{{$t(page+'.Instructions')}}</v-card-title
        >
        <v-row class="mx-5">
          <v-col md="6" cols="12">
            <p>L'elenco Topics viene generato dinamicamente leggendo i topics delle FAQ attive, pertanto per eliminare un Topic basta fare in modo che nessuna FAQ lo contenga</p>
          </v-col>  
          <v-col md="6" cols="12">
            <p>I Dipartimenti possono essere creati solo da utente con livello privilegi>10.<br>Per ogni Dipartimento va definito il privilegio minimo per potervi accedere</p>
            <p>I Quick Buttons sono a livello personale, pertanto ogni utente può creare i propri</p>            
          </v-col>  
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"  @click="instructions_dialog=false">
            {{$t(page+'.Close')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    drawer: Boolean,
    group: Object,
    onToggleDrawer: Function,
    depts: Array,
    level: Number
  },
  data() {
    return {
      userDetailMenu: false,
      activeDept:null,
      page:'BossTickets',
      instructions_dialog:false
    };
  },
  methods:
  {
    changeDept()
    {
      //console.log(43,this.activeDeptId);
      //console.log(44,this.depts.find(d => d.id==this.activeDept));
      const w=this.activeDeptId===undefined?null:this.depts[this.activeDeptId].deptId;
      console.log(45,w);
      this.$emit('selectedDept', w)
    },
    deptDialog()
    {
      console.log(94);
      this.$emit('deptDialog', true)
    },
    editDialog()
    {
      console.log(98);
      this.$emit('editDialog', true)
    }
  }
};
</script>
